import { render, staticRenderFns } from "./SvgContainer.vue?vue&type=template&id=c0db9dde&scoped=true"
import script from "./SvgContainer.vue?vue&type=script&lang=js"
export * from "./SvgContainer.vue?vue&type=script&lang=js"
import style0 from "./SvgContainer.vue?vue&type=style&index=0&id=c0db9dde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0db9dde",
  null
  
)

export default component.exports